import { render } from "./SystemAdmin18.vue?vue&type=template&id=5d376365&scoped=true"
import script from "./SystemAdmin18.vue?vue&type=script&lang=js"
export * from "./SystemAdmin18.vue?vue&type=script&lang=js"

import "./SystemAdmin18.vue?vue&type=style&index=0&id=5d376365&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d376365"]])

export default __exports__